var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-10 bg-white" },
      [
        _c(
          "div",
          { staticClass: "mb-10 flex align-center" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "medium", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ path: "/home/feedbackEdit" })
                  },
                },
              },
              [_vm._v("提交工单")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            attrs: {
              id: "order_table",
              data: _vm.list,
              "element-loading-text": "Loading",
              stripe: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "问题类型", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.issueArr[scope.row.type]) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "反馈内容" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.content || "--") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "错误截图", width: "220" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-wrap" },
                        _vm._l(scope.row.img_url, function (item) {
                          return _c("el-image", {
                            staticClass: "mr-5",
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: {
                              src: item,
                              "preview-src-list": scope.row.img_url,
                            },
                          })
                        }),
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "反馈时间", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.parseTime(scope.row.add_date, "{m}-{d} {h}:{i}")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "回复" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "fs-s1 text-gray" },
                        _vm._l(scope.row.reply_list, function (item) {
                          return _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.parseTime(
                                    item.add_date,
                                    "{m}-{d} {h}:{i}"
                                  )
                                ) +
                                "回复：" +
                                _vm._s(item.content) +
                                "\n            "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listQuery.page_num > 0,
                  expression: "listQuery.page_num > 0",
                },
              ],
              attrs: {
                page: _vm.listQuery.start,
                limit: _vm.listQuery.limit,
                "page-count": _vm.listQuery.page_num,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "start", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "limit", $event)
                },
                pagination: _vm.getList,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }